import missionAdvanceRequest from '@/api/mission/mission-advance-request'

export const state = {
  records: [],
  loading: false
}

export const mutations = {
  SET_RECORDS(state, data) {
    state.records = data
  },
  SET_LOADING(state, val) {
    state.loading = val
  }
}

export const getters = {}

export const actions = {
  async fetch({ commit }, missionId) {
    commit('SET_LOADING', true)
    const response = await missionAdvanceRequest.get(missionId)
    commit('SET_RECORDS', response)
    commit('SET_LOADING', false)
  },

  store(context, data) {
    return missionAdvanceRequest.store(data)
  },

  update(context, { id, data }) {
    return missionAdvanceRequest.update(id, data)
  },

  destroy(context, id) {
    return missionAdvanceRequest.destroy(id)
  }
}